module.exports = __webpack_public_path__ + "img/pgd_a_11100.4274af4a.png";